import { Button, CircularProgress, Grid, List, ListItem, ListItemButton, TextField } from "@mui/material";
import { useEffect, useReducer, useRef, useState } from "react";
import StorylineServerProxy  from "../storyline-proxy/storyline-proxy";

export function ScrapersEditor(){

    let [scrapers, setScrapers] = useState([] as any[]);
    let [scraperNames, setScraperNames] = useState([] as string[]);
    let [selectedScraperIndex, setSelectedScraperIndex] = useState(-1);

    let [runOneRunning, setRunOneRunning] = useState(false);

    let [needUpdate, setNeedUpdate] = useState(false);

    let [updatedScraper, updatedScraperDispatch] = useReducer((state, action) => {
        let reduced = { ...state, ...action };
        return reduced;
    }, {});

    function extractScraperNames(){
        let allScraperNames = [] as string[];
        scrapers.map(scraper => allScraperNames.push(scraper.name));
        setScraperNames(allScraperNames);
    }

    function loadScrapers(){
        StorylineServerProxy.getScrapers().then((allScrapers) => {
            setScrapers(allScrapers);
        });
    }

    useEffect(
        () => {
            loadScrapers();
    }, []);

    useEffect(() => {
        extractScraperNames();
    }, [scrapers]);


    useEffect(
        () => {
            if(needUpdate){
                if(confirm("Unsaved changes will be lost, as your sure?")){
                    // This is to discard the changes
                    let newScrapers = [... scrapers];
                    setScrapers(newScrapers);   
                    updatedScraperDispatch(scrapers[selectedScraperIndex]);
                    setNeedUpdate(false);
                }
            }
            else{
                updatedScraperDispatch(scrapers[selectedScraperIndex]);
            }
        }, [selectedScraperIndex]
    )

    function handleUpdateClicked(){
        let newScrapers = [... scrapers];
        newScrapers[selectedScraperIndex] = updatedScraper;
        setScrapers(newScrapers);
        StorylineServerProxy.updateScraper(updatedScraper);
        setNeedUpdate(false);
    }

    function handleLocalChange(){
        setNeedUpdate(true);
    }

    function handleDeleteClicked(){
        if(confirm("Delete scraper " + updatedScraper.name + "?")){
            // NOTE: updatedScraper can have a name which is changed but not in the database, therefore use the original name from the scrapers array.
            StorylineServerProxy.deleteScraper(scrapers[selectedScraperIndex].name);
            setNeedUpdate(false);
            setSelectedScraperIndex(-1);
            loadScrapers();
        }
    }

    function handleRunClicked(){
        setRunOneRunning(true);
        StorylineServerProxy.runOneScraper(updatedScraper, true).then(() => { setRunOneRunning(false) });
    }

    function handleRunWithWindowClicked(){
        setRunOneRunning(true);
        StorylineServerProxy.runOneScraper(updatedScraper, false).then(() => { setRunOneRunning(false) });
    }


    return(
        <Grid container >
            <Grid sx={{ padding: 2 }} xs={3}>
                <ScrapersList scraperNames={scraperNames} selectedScraperIndex={selectedScraperIndex} setSelectedScraperIndex={setSelectedScraperIndex}/>
            </Grid> 
            <Grid  sx={{ padding: 2 }} xs={9}>
            {
                selectedScraperIndex != -1?(<>
                    <ScraperDetails scraper={scrapers[selectedScraperIndex]} scraperDispatch={updatedScraperDispatch} setUpdateNeeded={handleLocalChange}/><br/>
                    <Button color={needUpdate?"error":"primary"} onClick={handleUpdateClicked} >Update</Button>
                    { runOneRunning?<CircularProgress />:<><Button onClick={handleRunClicked} >Run</Button><Button onClick={handleRunWithWindowClicked} >Run with window</Button></> }
                    <Button color="error" onClick={handleDeleteClicked}>Delete</Button>
                </>):<></>
            }
            </Grid> 
        </Grid>
    )
}

export function ScraperCreator(){

    let [scraper, scraperDispatch] = useReducer((state, action) => {
        let reduced = { name: "", company: "", url: "", regex: "", interval: 6 * 60 * 60 * 1000, ...state, ...action };
        return reduced;
    }, {});

    function handleClick(){
        StorylineServerProxy.createScraper(scraper).then(() => {
            alert("Scraper created successfully");
            scraperDispatch({ name: "", url: "", regex: "", interval: 6 * 60 * 60 * 1000 });
        });
    }

    return (
        <>
            <ScraperDetails scraper={scraper} scraperDispatch={scraperDispatch} creationMode={true}/>
            <br/>
            <Button onClick={handleClick}>Create</Button>
        </>
    )
}

function ScraperDetails({ scraper, scraperDispatch, setUpdateNeeded = () => {}, creationMode=false }){
    let [name, setName] = useState(scraper.name);
    let [url, setUrl] = useState(scraper.url);
    let [company, setCompany] = useState(scraper.company);
    let [regexp, setRegexp] = useState(scraper.regex as string);

    useEffect(() => {
        setName(scraper.name);
        setUrl(scraper.url);
        // NOTE: temporary handling of possibly empty regexp, should be soled in mongo
        if(scraper.regex == null){
            scraperDispatch({ regex: "" });
            setRegexp("");
        }
        else{
            setRegexp(scraper.regex);
        }
        if(scraper.company == null){
            setCompany("");
        }
        else{
            setCompany(scraper.company);
        }
    }, [scraper]);


    function handleReprocessLastScrapClicked(){
        StorylineServerProxy.reprocessLastScrap(scraper._id);
    }

    return(
        <>
            <TextField sx={{width: 9/10}} placeholder="Scraper name" value = {name} onBlur={(event) => {scraperDispatch({ name: name })}} onChange={(event) => { setName(event?.target.value); setUpdateNeeded() }} />
            <br/>
            <TextField sx={{width: 9/10}} placeholder="URL to scrap, including https://... " value = { url } onBlur={(event) => {scraperDispatch({ url: url })}} onChange={(event) => { setUrl(event?.target.value); setUpdateNeeded() }} />
            <Button onClick={() => { window.open(url)}}>Open</Button>
            <br/>
            <TextField placeholder="Regular expression to be applied before checking unicity" sx={{width: 9/10}} value = { regexp } onBlur={(event) => {scraperDispatch({ regex: regexp })}} onChange={(event) => { setRegexp(event?.target.value); setUpdateNeeded(); }} />
            <br/>
            <TextField placeholder="Company name, in case this is a jobs scraper" sx={{width: 9/10}} value = { company } onBlur={(event) => {scraperDispatch({ company: company })}} onChange={(event) => { setCompany(event?.target.value); setUpdateNeeded(); }} />
            <br/>
            {
                creationMode == false?(
                    <>
                        Last run: { new Date(scraper.lastRun).toUTCString() }
                        <br/>
                        <Button onClick={handleReprocessLastScrapClicked}>Reprocess last scrap</Button>
                        <br/>
                        URL test result:<br/>
                        {
                            scraper.urlTestResult != null?(
                            <>
                                { scraper.urlTestResult.statusMessage } ({ scraper.urlTestResult.statusCode }) on { scraper.urlTestResult.timestampFormatted }<br/>
                                { scraper.urlTestResult.error != null ? (<>{scraper.urlTestResult.error}</>):(<></>) } 
                                { scraper.urlTestResult.redirectLink != null ? (<>{scraper.urlTestResult.redirectLink}</>):(<></>) } 
                            </>)
                            :(<>No test results available</>)
                        }

                    </>
                )
                :(<></>)
            }
        </>
    )
}


export const ScrapersList = ({ scraperNames, selectedScraperIndex, setSelectedScraperIndex }) => {
    let [filter, setFilter] = useState("");


    function handleClick(index: number){
        setSelectedScraperIndex(index);
    }

    function handleFilterChange(event){
        setFilter(event.target.value);
    }

    return(
        <>
        <TextField placeholder="Filter..." onChange={handleFilterChange}></TextField>
        <br/>
        <List sx={{maxHeight: 600, overflow: 'scroll'}} dense={true}>
        {
            scraperNames != null?(
                scraperNames.map((scraperName, index) => {
                    if(scraperName.toUpperCase().includes(filter.toUpperCase())){
                        return <><ListItemButton selected={selectedScraperIndex == index} onClick={() => { handleClick(index)}}>{index}: {scraperName}</ListItemButton><br/></>
                    }
                    else{
                        return null;
                    }
                })    
            ):"Loading..."
        }
        </List>
        </>
    )
}